import { combineReducers } from "redux";
import authReducer from "./authReducer";
import waitingReducer from "./waitingReducer";
import getReducer from "./getReducer";
import tournamentsReducer from "./tournamentsReducer";
import matchesReducer from "./matchesReducer";

export default combineReducers({
    auth: authReducer,
    wait: waitingReducer,
    records: getReducer,
    matches: matchesReducer,
    tournaments: tournamentsReducer,
});